import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Factory } from "lucide-react";
import api from "../lib/api";
import { PageHeader, Spinner } from "../components/common";

export default function Manufacturers() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/manufacturers").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div data-testid="manufacturers-page">
      <PageHeader eyebrow="Directory" title="Manufacturers" subtitle="Aircraft makers building the world's fleets." />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pb-16">
        {!items ? <Spinner /> : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
            {items.map((m) => (
              <Link key={m.name} to={`/manufacturers/${encodeURIComponent(m.name)}`} data-testid={`mfr-card-${m.name}`}
                className="group border border-zinc-300 bg-white p-5 hover:-translate-y-px hover:border-primary transition-[transform,border-color]">
                <div className="w-10 h-10 bg-primary/10 text-primary flex items-center justify-center mb-3 group-hover:bg-primary group-hover:text-white transition-colors">
                  <Factory className="w-5 h-5" />
                </div>
                <div className="font-heading font-700 truncate">{m.name}</div>
                <div className="text-xs text-muted-foreground font-mono mt-1">{m.count} aircraft types</div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
